// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_card_XpUSNUsighTJf39C8wqY {
  background-color: #ffffff;
  margin: 8px;
  width: 350px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 15px 25px -15px rgba(0, 0, 0, 0.1);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
@media screen and (max-width: 1200px) {
  .style-module_card_XpUSNUsighTJf39C8wqY {
    width: 500px;
  }
}

.style-module_heading_q4ve0JtYxoweJtiTpZiw {
  font-size: 16px;
  line-height: 25.6px;
  font-weight: 700;
}

.style-module_value_ztVyBQZw_a3KFS6ifamm {
  font-size: 29px;
  line-height: 36.3px;
  font-weight: 600;
  margin-bottom: 4px;
}

.style-module_subheading_I3SlGG0eNKgk9uyAESBs {
  font-size: 15px;
  font-weight: 400;
}
.style-module_subheading_I3SlGG0eNKgk9uyAESBs div {
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
}
.style-module_subheading_I3SlGG0eNKgk9uyAESBs div a {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/containers/WfpManagerHome/components/SummaryCard/style.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;EACA,+EAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;AAHF;AAKE;EAfF;IAgBI,YAAA;EAFF;AACF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;AAGE;EACE,qBAAA;EACA,kBAAA;AADJ;AAEI;EACE,kBAAA;AAAN","sourcesContent":[".card {\n  background-color: #ffffff;\n  margin: 8px;\n  //height: 80px;\n  width: 350px;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05),\n    0 15px 25px -15px rgba(0, 0, 0, 0.1);\n  //padding: 20px;\n  padding: 20px 16px;\n  display: flex;\n  flex-direction: column;\n  // justify-content: space-between;\n  text-align: center;\n\n  @media screen and (max-width: 1200px) {\n    width: 500px;\n  }\n}\n\n.heading {\n  font-size: 16px;\n  line-height: 25.6px;\n  font-weight: 700;\n}\n\n.value {\n  font-size: 29px;\n  line-height: 36.3px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.subheading {\n  font-size: 15px;\n  font-weight: 400;\n  div {\n    margin-bottom: 0.3rem;\n    margin-top: 0.3rem;\n    a {\n      margin-right: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `style-module_card_XpUSNUsighTJf39C8wqY`,
	"heading": `style-module_heading_q4ve0JtYxoweJtiTpZiw`,
	"value": `style-module_value_ztVyBQZw_a3KFS6ifamm`,
	"subheading": `style-module_subheading_I3SlGG0eNKgk9uyAESBs`
};
export default ___CSS_LOADER_EXPORT___;
